import Tree, { TreeNode, TreeNodeProps } from "rc-tree";
import { DataNode } from "rc-tree/lib/interface";
import { ReactNode } from "react";
import expandIcon from "../../../assets/tree/expand_arrow.svg";
import { IManageTreeItem } from "../../../models/tree.interface";
import styles from "./ManagementTree.module.css";
import ManagementTreeItem from "./ManagementTreeItem";

interface IManageTreeDataNode extends DataNode, IManageTreeItem<any> {}

type ManagementTreeProps<T extends IManageTreeItem<any>> = {
  data?: T[];
  treeItemMapper: (item: T, nodeLevel?: number) => ReactNode;
  defaultExpandAll?: boolean;
};

const ManagementTree = <T extends IManageTreeItem<any>>({
  data,
  defaultExpandAll = false,
  treeItemMapper,
}: ManagementTreeProps<T>) => {
  const renderTreeNodes = (data: T[], nodeLevel?: number) => {
    return data.map((item: T) => {
      const isLeaf = !item.childNodes?.length;
      const dataItem: IManageTreeDataNode = { ...item, key: item.id };

      return (
        <TreeNode
          key={item.id}
          data={dataItem}
          isLeaf={isLeaf}
          title={
            treeItemMapper && (
              <ManagementTreeItem>
                {treeItemMapper(item, item.levelInTree ?? nodeLevel)}
              </ManagementTreeItem>
            )
          }
          className="py-3"
        >
          {!isLeaf
            ? renderTreeNodes(
                item.childNodes!,
                item.levelInTree ?? nodeLevel! + 1
              )
            : null}
        </TreeNode>
      );
    });
  };

  const setSwitcherIcon = (obj: TreeNodeProps) => {
    // @ts-ignore
    if (obj.isLeaf || !obj.data?.data?.childNodes?.length)
      // Returning empty wrapper to align rows with no children
      return <div className={styles.treeExpandToggleWrapper}></div>;

    return (
      <div className={styles.treeExpandToggleWrapper}>
        {obj.expanded ? (
          <img
            className="cursor-pointer w-100 h-100"
            style={{ transform: "rotate(90deg) scale(1.8)" }}
            src={expandIcon}
            alt=""
          />
        ) : (
          <img
            className="cursor-pointer w-100 h-100"
            style={{ transform: "scale(1.8)" }}
            src={expandIcon}
            alt=""
          />
        )}
      </div>
    );
  };

  return (
    <div className={styles.tree}>
      <Tree
        showLine
        defaultExpandAll={defaultExpandAll}
        switcherIcon={setSwitcherIcon}
        showIcon={false}
      >
        {renderTreeNodes(data ?? [], 0)}
      </Tree>
    </div>
  );
};

export default ManagementTree;
